import React from 'react';
import { translate } from '../Services/translation';

const getTotal = (articles = []) => {
    var total = 0;

    articles.forEach(article => {
        var variant = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];

        if (variant != undefined) {
            total += (variant.price * article.defaultAmmount);
        }
    });

    return total;
}

const getTotalList = (articles = []) => {
    var total = 0;

    articles.forEach(article => {
        var variant = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];

        if (variant != undefined) {
            total += (variant.listPrice * article.defaultAmmount);
        }
    });

    return total;
}

const getDelivery = (articles = []) => {

    var statusCodes = [
        'RedMax',
 	'RedHighest',
        'RedHigh',
        'RedMed',
        'RedLow',
        'Yellow',
        'Green'
    ];

    var status = '';
    var selectedArticles = [];
    articles.forEach(article => {
        var selected = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];
        if (selected != undefined) {
            selectedArticles.push(selected);
        }
    });

    statusCodes.forEach(code => {
        if (status == '') {
            var article = selectedArticles.filter(x => x.deliveryStatus != null && x.deliveryStatus.startsWith(code))[0];
            if (article != undefined) {
                status = article.deliveryText;
            }
        }
    });

    return status;
}

const getProduct = (article, increment, decrement, changeVariant) => {
    var variant = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];
    if (variant == undefined) {
        variant = article.configVariants[0];
    }

    return <li key={article.defaultVariant}><h3>{article.name}</h3>
        <ul>
            <li>
                <div className="button-holder"><button onClick={() => decrement(article.defaultVariant)} className="minus"></button>{article.defaultAmmount}<button onClick={() => increment(article.defaultVariant)} className="plus"></button></div>
                <div className="variant-holder">
                    {article.configVariants.length > 1 ? (<div className="has-variants" onClick={(e) => toggleVariants(e)}><img src={variant.defaultImageUrl} />{displayVariantContent(variant, true)}</div>)
                        : (<div><img src={variant.defaultImageUrl} />{displayVariantContent(variant, true)}</div>)}
                    <div className="variants">
                        <ul>
                            {article.configVariants.map(variant1 => <li key={variant1.sku} onClick={(e) => clickVariant(e, changeVariant, article.defaultVariant, variant1.sku)}><img src={variant1.defaultImageUrl} />{variantContent(variant1)}</li>)}
                        </ul>
                    </div>
                </div>
            </li>
        </ul></li>;
}

const variantContent = (variant) => {
    if (variant.listPrice != variant.price)
        return <span className="price">
            {variant.name}
            <span className="price">
                <span className="extra-price">{translate('currency.prefix')}{variant.price}{translate('currency.suffix')}</span> <span className="old-price">{translate('currency.prefix')}{variant.listPrice}{translate('currency.suffix')}</span>
            </span>
            <span className="stock-status">{variant.deliveryText}</span>
        </span>;
    return <span className="price">
            {variant.name} {translate('currency.prefix')}{variant.price}{translate('currency.suffix')}
            <span className="stock-status">{variant.deliveryText}</span>
        </span>;
}

const displayVariantContent = (variant, display = false) => {
    if (variant.listPrice != variant.price)
        return <span>
            {variant.name}
            {display ? <span className="price"><span className="extra-price">{translate('currency.prefix')}{variant.price}{translate('currency.suffix')}</span> <span className="old-price">{translate('currency.prefix')}{variant.listPrice}{translate('currency.suffix')}</span></span> : ''}
            <span className="stock-status">{display ? variant.deliveryText : ""}</span>
        </span>;
    return <span>
            {variant.name} {display ? translate('currency.prefix') + variant.price + translate('currency.suffix') : ''}
            <span className="stock-status">{display ? variant.deliveryText : ""}</span>
        </span>;
}

const toggleVariants = (event) => {
    var target = event.target.parentNode;
    if (!target.classList.contains('variant-holder')) {
        var attempts = 0;
        while (!target.classList.contains('variant-holder')) {
            target = target.parentNode;
            ++attempts;
            if (attempts >= 5) {
                break;
            }
        }
    }
    target.firstChild.classList.add('active');
    target.lastChild.style.display = 'block'
}

const clickVariant = (event, changeVariant, oldId, newId) => {

    if (newId == oldId) {
        var target = event.target.parentNode;
        if (!target.classList.contains('variant-holder')) {
            var attempts = 0;
            while (!target.classList.contains('variant-holder')) {
                target = target.parentNode;
                ++attempts;
                if (attempts >= 5) {
                    break;
                }
            }
        }
        target.firstChild.classList.remove('active');
        target.lastChild.style.display = 'none'
    } else {
        changeVariant(oldId, newId);
    }
}

const isDisabled = (articles = []) => {

    var disabled = false;

    articles.forEach(article => {
        var selected = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];
        if (selected != undefined && selected.soldOut) {
            disabled = true;
        }
    });

    return disabled;
}

const ProductConfigurator = ({ articles, emptyArticles, increment, decrement, label, labelEmpty, cssClass, onClick, changeVariant, baseProduct, children }) => {
    if ((getTotalList(articles)) != getTotal(articles))
        return <div className="ProductConfigurator">
            <ul>
                {articles.map(article => getProduct(article, increment, decrement, changeVariant))}
                {emptyArticles.map(article => {
                   return <li key={article.defaultVariant}><h3>{article.name}</h3>
                   <ul>
                       <li><p>{labelEmpty}</p></li>
                   </ul></li>
                })}
            </ul>
            <div className="price-holder">
                <div className="price"><span className="campaign-price">{translate('currency.prefix')}{getTotal(articles)}{translate('currency.suffix')}</span> <span className="old-price">{translate('currency.prefix')}{getTotalList(articles)}{translate('currency.suffix')}</span></div>
                <div className="excl-vat">Exkl. moms</div>
            </div>
            <div className={isDisabled(articles) ? "alternative-config-summary disabled" : "alternative-config-summary"}>
                {children}
            </div>
                <div><span className="status-text">{getDelivery(articles)}</span></div>
        </div>
    else
        return <div className="ProductConfigurator">
            <ul>
                {articles.map(article => getProduct(article, increment, decrement, changeVariant))}
                {emptyArticles.map(article => {
                   return <li key={article.defaultVariant}><h3>{article.name}</h3>
                   <ul>
                       <li><p>{labelEmpty}</p></li>
                   </ul></li>
                })}
            </ul>
            <div className="price-holder">
                <div className="price">{translate('currency.prefix')}{getTotal(articles)}{translate('currency.suffix')}</div>
                <div className="excl-vat">Exkl. moms</div>
            </div>
            <div className={isDisabled(articles) ? "alternative-config-summary disabled" : "alternative-config-summary"}>
                {children}
            </div>
                    <div><span className="status-text">{getDelivery(articles)}</span></div>
        </div>
}

export default ProductConfigurator;